import { render, staticRenderFns } from "./activity-buttons.vue?vue&type=template&id=4bf1e1b1"
import script from "./activity-buttons.vue?vue&type=script&lang=js"
export * from "./activity-buttons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports